
import { RoadmapTemplate, User } from '@/types/roadmap';

export const initialUsers: User[] = [
  {
    id: 'admin-user-id',
    username: 'admin',
    isAdmin: true,
    email: 'admin@example.com'
  }
];

// Export adminUser for backward compatibility
export const adminUser: User = initialUsers[0];

export const mockTemplate: RoadmapTemplate = {
  id: 'mock-template-id',
  title: 'Sample Marketing Roadmap',
  description: 'A comprehensive guide to marketing strategy',
  pageTitle: 'Marketing Strategy Guide',
  embedUrl: 'https://example.com/embed',
  embedTitle: 'Marketing Video',
  accessType: 'public',
  isPublic: true,
  tags: ['marketing', 'strategy'],
  steps: [
    {
      id: 'step-1',
      title: 'Define Your Target Audience',
      description: 'Learn how to identify and understand your ideal customers',
      isOpenDefault: true,
      walkthrough: {
        title: 'Target Audience Workshop',
        videoUrl: 'https://example.com/video1',
        description: 'Interactive workshop on audience identification',
        iframeSrc: 'https://example.com/embed1',
        downloadLink: 'https://example.com/download1',
        downloadText: 'Download Walkthrough'
      }
    }
  ],
  sidebar: {
    examples: [
      { text: 'Marketing Case Study 1', href: 'https://example.com/case1', description: 'Success story' }
    ],
    usefulTools: [
      { label: 'Analytics Tool', url: 'https://analytics.example.com' }
    ],
    bonusActivities: [
      {
        id: 'activity-1',
        title: 'Audience Research',
        description: 'Deep dive into customer research',
        href: 'https://example.com/activity1',
        iconPlaceholder: 'AR'
      }
    ]
  }
};

// Export initialTemplates for backward compatibility
export const initialTemplates: RoadmapTemplate[] = [mockTemplate];
